import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const PORTAL_TOKEN_KEY = 'envideo_token'
const PORTAL_USER_KEY = 'envideo_user'
const ADMIN_TOKEN_KEY = 'admin_token'
const ADMIN_INFO_KEY = 'admin_info'
const ADMIN_MENUS_KEY = 'admin_menus'

function readJson(key, fallback = null) {
  try {
    const raw = sessionStorage.getItem(key)
    return raw ? JSON.parse(raw) : fallback
  } catch {
    return fallback
  }
}

export default new Vuex.Store({
  state: {
    token: sessionStorage.getItem(PORTAL_TOKEN_KEY) || '',
    user: readJson(PORTAL_USER_KEY),
    adminToken: sessionStorage.getItem(ADMIN_TOKEN_KEY) || '',
    adminInfo: readJson(ADMIN_INFO_KEY),
    adminMenus: readJson(ADMIN_MENUS_KEY, [])
  },
  getters: {
    token: state => state.token,
    user: state => state.user,
    isLoggedIn: state => !!state.token,
    adminToken: state => state.adminToken,
    adminInfo: state => state.adminInfo,
    adminMenus: state => state.adminMenus,
    isAdminLoggedIn: state => !!state.adminToken
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token || ''
      if (token) {
        sessionStorage.setItem(PORTAL_TOKEN_KEY, token)
      } else {
        sessionStorage.removeItem(PORTAL_TOKEN_KEY)
      }
    },
    SET_USER(state, user) {
      state.user = user
      if (user) {
        sessionStorage.setItem(PORTAL_USER_KEY, JSON.stringify(user))
      } else {
        sessionStorage.removeItem(PORTAL_USER_KEY)
      }
    },
    SET_ADMIN_TOKEN(state, token) {
      state.adminToken = token || ''
      if (token) {
        sessionStorage.setItem(ADMIN_TOKEN_KEY, token)
      } else {
        sessionStorage.removeItem(ADMIN_TOKEN_KEY)
      }
    },
    SET_ADMIN_INFO(state, info) {
      state.adminInfo = info
      if (info) {
        sessionStorage.setItem(ADMIN_INFO_KEY, JSON.stringify(info))
      } else {
        sessionStorage.removeItem(ADMIN_INFO_KEY)
      }
    },
    SET_ADMIN_MENUS(state, menus) {
      state.adminMenus = menus || []
      sessionStorage.setItem(ADMIN_MENUS_KEY, JSON.stringify(state.adminMenus))
    },
    LOGOUT(state) {
      state.token = ''
      state.user = null
      sessionStorage.removeItem(PORTAL_TOKEN_KEY)
      sessionStorage.removeItem(PORTAL_USER_KEY)
    },
    ADMIN_LOGOUT(state) {
      state.adminToken = ''
      state.adminInfo = null
      state.adminMenus = []
      sessionStorage.removeItem(ADMIN_TOKEN_KEY)
      sessionStorage.removeItem(ADMIN_INFO_KEY)
      sessionStorage.removeItem(ADMIN_MENUS_KEY)
    }
  },
  actions: {
    setAuth({ commit }, { token, user }) {
      commit('SET_TOKEN', token)
      commit('SET_USER', user)
    },
    logout({ commit }) {
      commit('LOGOUT')
    },
    setAdminAuth({ commit }, { token, adminInfo, menus }) {
      commit('SET_ADMIN_TOKEN', token)
      commit('SET_ADMIN_INFO', adminInfo)
      commit('SET_ADMIN_MENUS', menus)
    },
    adminLogout({ commit }) {
      commit('ADMIN_LOGOUT')
    }
  }
})
